import { render, staticRenderFns } from "./AppPreviewHeader.vue?vue&type=template&id=07c2bcfb&scoped=true&"
import script from "./AppPreviewHeader.vue?vue&type=script&lang=js&"
export * from "./AppPreviewHeader.vue?vue&type=script&lang=js&"
import style0 from "./AppPreviewHeader.vue?vue&type=style&index=0&id=07c2bcfb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c2bcfb",
  null
  
)

export default component.exports